module.exports = __webpack_public_path__ + "img/mode_outline_2.0ccaa977.png";